import { admins } from './admins';
import { advertising } from './advertising';
import { aiChatBots } from './aiChatBots';
import { aiPromptsServices } from './aiPrompts';
import { aiServices } from './aiServicese';
import { apkFiles } from './apkFiles';
import { auth } from './auth';
import { banInfo } from './banInfo';
import { channels } from './channels';
import { dashboard } from './dashboard';
import { finance } from './finance';
import { moderation } from './moderation';
import { mailer } from './mailer';
import { reactions } from './reactions';
import { referral } from './referral';
import { reports } from './reports';
import { reserved } from './reserved';
import { support } from './support';
import { transaction } from './transactions';
import { IApi } from './types';
import { users } from './users';
import { utils } from './utils';

const api: IApi = {
  auth,
  banInfo,
  channels,
  users,
  transaction,
  reports,
  admins,
  support,
  aiServices,
  reserved,
  utils,
  finance,
  referral,
  apkFiles,
  aiChatBots,
  reactions,
  dashboard,
  aiPromptsServices,
  moderation,
  mailer,
  advertising,
};

export { api };
